/**
 * Legacy channel mismatch hints (EU vs US). The storefront now uses a single channel (`eu`);
 * we never suggest switching regions.
 */
export type MismatchDecision =
	| { kind: "none" }
	| { kind: "suggest-americas"; detectedCountry: string }
	| { kind: "suggest-worldwide"; detectedCountry: string };

export function classifyMismatch(_params: {
	currentChannel: string;
	detectedCountry: string | null;
}): MismatchDecision {
	return { kind: "none" };
}
